import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  DetailsList,
  DetailsListLayoutMode,
} from 'office-ui-fabric-react/lib/DetailsList';

import { localizable } from '../../../components/Localization';
import Loading from '../../../components/LoadingOverlay';
import OfferNotificationDetails from './OfferNotificationDetails';

const columns = t => [
  {
    key: 'created',
    name: t('Created On'),
    fieldName: 'createdAt',
    columnActionsMode: null,
    minWidth: 200,
    maxWidth: 200,
    isSorted: true,
    isSortedDescending: true,
  },
  {
    key: 'recipient',
    name: t('Recipient'),
    fieldName: 'recipient',
    columnActionsMode: null,
    minWidth: 200,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'template',
    name: t('Template'),
    fieldName: 'template',
    columnActionsMode: null,
    minWidth: 200,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'status',
    name: t('Status'),
    fieldName: 'status',
    columnActionsMode: null,
    minWidth: 100,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'updated',
    name: t('Updated On'),
    fieldName: 'updatedAt',
    columnActionsMode: null,
    minWidth: 200,
    maxWidth: 200,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'serviceStatus',
    name: t('Service Status'),
    fieldName: 'serviceResponse',
    columnActionsMode: null,
    minWidth: 200,
    isSorted: false,
    isSortedDescending: false,
  },
];

@localizable
@observer
class OfferNotificationsList extends Component {
  handleRenderItemColumn = (item, index, column) => {
    const { t } = this.props;
    const content = item[column.fieldName];
    switch (column.key) {
      case 'template':
        const canonical = content
          .replace(/^(open|sealed|registration)_/, '')
          .replace(/^(cust_round_closing)_.*$/, '$1')
          .toLowerCase();
        return (
          <span>
            {t(`notificationemailtemplate::${canonical}`)}
          </span>
        );
      case 'status':
        return (
          <span>
            {t(`notificationservicestatus::${content.toLowerCase()}`)}
          </span>
        );
      case 'created':
      case 'updated':
        return <span>{content && content.toFormattedDateTimeString()}</span>;
      case 'serviceStatus':
        return (
          <span>
            {content}
            {content && <OfferNotificationDetails item={item} />}
          </span>
        );
      default:
        return <span>{content}</span>;
    }
  };

  render() {
    const { t, store } = this.props;
    return (
      <div>
        <Loading
          label={`${t('Loading')}...`}
          fullscreen={true}
          isVisible={store.fetching}
        />
        {!store.fetching && store.succeeded && (
          <DetailsList
            columns={columns(t)}
            items={store.list}
            onRenderItemColumn={this.handleRenderItemColumn}
            selectionMode={0}
            checkboxVisibility={0}
            layoutMode={DetailsListLayoutMode.justified}
          />
        )}
        {!store.fetching && store.failed && t('Error loading')}
      </div>
    );
  }
}

export default OfferNotificationsList;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/OfferNotificationsList.jsx